import React from "react";
import {
  Container,
  Header,
  Grid,
  Icon,
  Button
} from "semantic-ui-react";
import { PAGE_SIZE } from "../constants";
import { NAV } from "../navLabels";
import './LandingPage.css';

const UserHome = ({ user, navigate }) => {
  return (
    <Container style={{ padding: "4em 0" }}>
      <div style={{ marginBottom: '3em' }}>
        <Header as="h1" className="welcome-header">
          {user?.full_name || user.username || "사용자"}님,<br/>환영합니다!
        </Header>
        <p style={{ fontSize: '1.3em', color: '#86868b' }}>
          오늘도 고객 응대 스킬을 향상시켜 볼까요?
        </p>
      </div>

      <Grid stackable columns={2} style={{ marginTop: "1em" }}>
        <Grid.Row stretched>
          <Grid.Column width={10}>
            <div 
              className="action-card-main" 
              style={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'center', 
                alignItems: 'center',
                padding: '40px',
                color: 'white',
                cursor: 'pointer'
              }}
              onClick={() => navigate(`/simulation`)}
            >
              <div style={{ 
                background: 'rgba(255,255,255,0.2)', 
                borderRadius: '50%', 
                width: '80px', 
                height: '80px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                marginBottom: '20px'
              }}>
                <Icon name="conversation" size="huge" style={{ margin: 0 }} />
              </div>
              <Header as="h2" style={{ color: 'white', fontSize: '2em', marginBottom: '0.5em' }}>
                {NAV.ROLEPLAY}
              </Header>
              <p style={{ fontSize: '1.2em', margin: '0 auto 30px', color: 'rgba(255,255,255,0.9)', maxWidth: '400px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                AI 기반 롤플레잉 시스템으로 다양한 고객 상황을 연습해보세요.
              </p>
              <Button 
                size="large" 
                style={{ 
                  borderRadius: '25px', 
                  background: 'white', 
                  color: '#007AFF', 
                  padding: '15px 40px',
                  fontWeight: 'bold'
                }}
              >
                새 세션 시작하기
                <Icon name="right arrow" style={{ marginLeft: '10px' }} />
              </Button>
            </div>
          </Grid.Column>

          <Grid.Column width={6}>
            <Grid stackable columns={1} style={{ height: '100%', margin: 0 }}>
              <Grid.Column style={{ height: '33.33%', padding: '0 0 16px 0' }}>
                <div 
                  className="dashboard-card" 
                  onClick={() => navigate("/userdashboard")}
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', margin: 0 }}
                >
                  <div style={{ 
                    background: 'rgba(0, 181, 173, 0.1)', 
                    borderRadius: '12px', 
                    padding: '12px',
                    marginRight: '20px'
                  }}>
                    <Icon name="dashboard" size="large" style={{ color: '#00B5AD', margin: 0 }} />
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 4px 0', fontSize: '1.2em' }}>내 대시보드</h3>
                    <div style={{ color: '#86868b' }}>성과 통계 확인</div>
                  </div>
                  <Icon name="angle right" size="large" style={{ marginLeft: 'auto', color: '#d2d2d7' }} />
                </div>
              </Grid.Column>
              <Grid.Column style={{ height: '33.33%', padding: '0 0 16px 0' }}>
                <div 
                  className="dashboard-card" 
                  onClick={() => navigate(`/chatsessionslist?page=1&page_size=${PAGE_SIZE}`)}
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', margin: 0 }}
                >
                  <div style={{ 
                    background: 'rgba(242, 113, 28, 0.1)', 
                    borderRadius: '12px', 
                    padding: '12px',
                    marginRight: '20px'
                  }}>
                    <Icon name="history" size="large" style={{ color: '#F2711C', margin: 0 }} />
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 4px 0', fontSize: '1.2em' }}>지난 대화 세션</h3>
                    <div style={{ color: '#86868b' }}>대화 기록 검토</div>
                  </div>
                  <Icon name="angle right" size="large" style={{ marginLeft: 'auto', color: '#d2d2d7' }} />
                </div>
              </Grid.Column>
              {user?.contractor?.knowledge_training_enabled !== false && (
                <Grid.Column style={{ height: '33.33%', padding: '0' }}>
                  <div 
                    className="dashboard-card" 
                    onClick={() => navigate(`/quiz/dashboard`)}
                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', margin: 0 }}
                  >
                    <div style={{ 
                      background: 'rgba(255, 214, 10, 0.1)', 
                      borderRadius: '12px', 
                      padding: '12px',
                      marginRight: '20px'
                    }}>
                      <Icon name="student" size="large" style={{ color: '#FFD60A', margin: 0 }} />
                    </div>
                    <div>
                      <h3 style={{ margin: '0 0 4px 0', fontSize: '1.2em' }}>{NAV.QUIZ}</h3>
                      <div style={{ color: '#86868b' }}>맞춤형 퀴즈 풀기</div>
                    </div>
                    <Icon name="angle right" size="large" style={{ marginLeft: 'auto', color: '#d2d2d7' }} />
                  </div>
                </Grid.Column>
              )}
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default UserHome;
